export default {
  'en-US': {
    'timeline': {
      'metadata': {
        Inserted: 'Created',
        Picked: 'Picked',
        Packed: 'Packed',
        Labeled: 'Labeled',
        PreTransit: 'Processing',
        InTransit: 'In-Transit',
        OutForDelivery: 'Out for Delivery',
        Delivered: 'Delivered',
        SplitAtFC: 'Split at FC'
      },
      'tooltip': {
        Inserted: 'Order created in ShipBob',
        Picked: 'Order has been picked ',
        Packed: 'Order has been packed',
        Labelled: 'Order label has been generated',
        Validated: 'Order has been shipped successfully',
        PreTransit: 'Order is being processed by the carrier',
        InTransit: 'Order is in transit',
        OutForDelivery: 'Order is out for delivery',
        Delivered: 'Order has been delivered',
        SplitAtFC: 'Order has been split at FC'
      }
    }
  }
}
